import { ERROR, PENDING, RESET_STATUS, SUCCESS } from "../config/types";

const initialState = { status: "", message: "" };

const responseStatusReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PENDING:
      return { ...state, status: PENDING, ...payload };
    case SUCCESS:
      return { ...state, status: SUCCESS, ...payload };
    case ERROR:
      return { ...state, status: ERROR, ...payload };
    case RESET_STATUS:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default responseStatusReducer;
